import { BASE_CONST } from "../BASE_CONST";
import { GHG_CONST } from "../GHG_CONST";

export const getConstByStandard = (type) => {
  switch (type) {
    case 1:
      return BASE_CONST;
    case 2:
      return GHG_CONST;
    default:
      return BASE_CONST;
  }
};
